import * as http from '../utils/http';

/**
 * 搜索酒店
 * trip_id : string , 当前行程id
 * poi_ids: string , 当天日程的poiid集合
 * keyword: keyword, 关键字
 * p: page 分页索引
 */
export function searchHotel(trip_id, poi_ids, keyword, p) {
  let url = '/m/v2/index.php?m=api/poi/search/hotel';
  return http.get(url, {
    data:{
      trip_id,
      poi_ids,
      keyword,
      p
    }
  });
}





/**
 * 获取推荐的酒店列表
 *  trip_id: 行程id,
    day: 当前是第几天,
    day_poi_citys: 每日天数与poi对应数据
 */
export function getRecommendHotel(trip_id, day, day_poi_citys) {
  let url = '/m/v2/?m=api/poi/get_recommend_hotel';
  return http.get(url, {
    data:{
      trip_id,
      day,
      day_poi_citys
    }
  });
}





/**
  * 1.3 获取自定义hotel点的完整poi结构
  * @param {string} cn_name	string	必填	自定义POI的中文名称
  * @param {strnumbering} lat	float	必填	纬度信息，有效精度8位
  * @param {number} lng	float	必填	经度信息，有效精度8位
  * @param {string}  trip_id	string	必填	当前对应行程的行程ID，并通过行程ID验证权限
  * @param {number} select_city_id	int	必填	选择的城市信息，此处为选择城市时的默认城市
  * @param {int} need_poi_info	int	选填	是否需要返回POI的信息，默认为0，当值为1时有效
 */
export function createCustomHotel(query) {
  let url = '/m/v2/?m=api/poi/user_custom/hotel/create_v1_3';

  return http.post(url, {
    data: {
      ...query,
      need_poi_info: 1
    }
  })
    .then(function (data) {
      return data;
    });
}


/**
 * 1.3 编辑自定义hotel点的完整poi结构
 * @param {*} query oneof.[cnname, lat, lng]
 */
export function updateCustomHotel(query) {
  let url = '/m/v2/?m=api/poi/user_custom/hotel/update_v1_3';

  return http.get(url, {
    data: {
      ...query, 
      need_poi_info: 1
    }
  })
    .then(function (data) {
      return data;
    });
}

export function saveGoogleResult(cache, name, trip_id) {
  let url = '/m/v2/index.php?m=api/poi/search/hotel_custom';
  return http.get(url, {
    data:{
      trip_id,
      name,
      cache
    }
  });
}




// WEBPACK FOOTER //
// ./src/services/hotel.js